const showBlock = function (robotType, blockSeparator, categorySeparator) {
    switch (robotType) {
        case 'E6':
            return `
                <category
                    name="%{BKY_CATEGORY_DISPLAY}"
                    id="show"
                    colour="#8dca5d"
                    secondaryColour="#73a749"
                    showLabelButton="true">
                <block type="show_getTouchScreen"/>
                <block type="show_getTouchScreenX"/>
                <block type="show_getTouchScreenY"/>
                ${blockSeparator}
                <block type="show_LCDClearScreen"/>
                <block type="show_SetFontSize"/>
                <block type="show_setLineNum">
                    <value name="LINES">
                        <shadow type="show_lines_menu">
                        </shadow>
                    </value>
                    <value name="LINENUMBER">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_setColor">
                    <value name="LINES">
                        <shadow type="show_lines_menu">
                        </shadow>
                    </value>
                    <value name="TEXT">
                        <shadow type="text">
                            <field name="TEXT">Hello</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_drawImage">
                    <value name="IMAGEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="IMAGEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="IMAGEFILENAME">
                        <shadow type="text">
                            <field name="TEXT">a.jpg</field>
                        </shadow>
                    </value>
                    <value name="IMAGESCALE">
                        <shadow type="math_number">
                            <field name="NUM">0</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="show_diplayData">
                    <value name="X">
                        <shadow type="show_lines_menu">
                        </shadow>
                    </value>
                    <value name="Y">
                        <shadow type="show_lines_menu">
                        </shadow>
                    </value>
                    <value name="DATA">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_displayCharacter">
                    <value name="X">
                        <shadow type="show_lines_menu">
                        </shadow>
                    </value>
                    <value name="Y">
                        <shadow type="show_lines_menu">
                        </shadow>
                    </value>
                    <value name="CHARACTER">
                        <shadow type="text">
                            <field name="TEXT">Hello</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_setDisplayVarU32">
                    <value name="LINE">
                        <shadow type="math_number">
                            <field name="NUM">1</field>
                        </shadow>
                    </value>
                    <value name="VALUE">
                        <shadow type="math_number">
                            <field name="NUM">1234567890</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_setDisplayFloat">
                    <value name="LINE">
                        <shadow type="math_number">
                            <field name="NUM">1</field>
                        </shadow>
                    </value>
                    <value name="VALUE">
                        <shadow type="math_number">
                            <field name="NUM">1.90</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="show_drawPoint">
                    <value name="POINTX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="POINTY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_drawCircle">
                    <value name="CIRCLEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="CIRCLEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="CIRCLERADIUS">
                        <shadow type="math_number">
                            <field name="NUM">5</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_drawLine">
                    <value name="LINEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="LINEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="LINEANGLE">
                        <shadow type="math_number">
                            <field name="NUM">45</field>
                        </shadow>
                    </value>
                    <value name="LINELENGTH">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_drawSolidRectangle">
                    <value name="SOLIDRECTANGLEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="SOLIDRECTANGLEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="SOLIDRECTANGLEWIDTH">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="SOLIDRECTANGLEHEIGHT">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_drawRectangle">
                    <value name="RECTANGLEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="RECTANGLEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="RECTANGLEWIDTH">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="RECTANGLEHEIGHT">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="RECTANGLELINEWIDTH">
                        <shadow type="math_number">
                            <field name="NUM">2</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                </category>
                `;
        case 'C1':
            return `
                <category
                    name="%{BKY_CATEGORY_DISPLAY}"
                    id="show"
                    colour="#8dca5d"
                    secondaryColour="#73a749">
                </category>
                `;
        case 'E3':
            return `
            <category
                name="%{BKY_CATEGORY_DISPLAY}"
                id="show"
                colour="#8dca5d"
                secondaryColour="#73a749">
            <block type="show_getTouchScreen"/>
            <block type="show_getTouchScreenX"/>
            <block type="show_getTouchScreenY"/>
            ${blockSeparator}
            <block type="show_setLCDBack"/>
            <block type="show_LCDClearScreen"/>
            <block type="show_setLineNum">
                <value name="LINES">
                    <shadow type="show_lines_menu">
                    </shadow>
                </value>
                <value name="LINENUMBER">
                    <shadow type="math_number">
                        <field name="NUM">10</field>
                    </shadow>
                </value>
            </block>
            <block type="show_setColor">
                <value name="LINES">
                    <shadow type="show_lines_menu">
                    </shadow>
                </value>
                <value name="TEXT">
                    <shadow type="text">
                        <field name="TEXT">Hello</field>
                    </shadow>
                </value>
            </block>
            <block type="show_drawImage">
                <value name="IMAGEX">
                    <shadow type="math_number">
                        <field name="NUM">10</field>
                    </shadow>
                </value>
                <value name="IMAGEY">
                    <shadow type="math_number">
                        <field name="NUM">10</field>
                    </shadow>
                </value>
                <value name="IMAGEFILENAME">
                    <shadow type="text">
                        <field name="TEXT">a.jpg</field>
                    </shadow>
                </value>
                <value name="IMAGESCALE">
                    <shadow type="math_number">
                        <field name="NUM">0</field>
                    </shadow>
                </value>
            </block>
            <block type="show_setDisplayVarU32">
                <value name="LINE">
                    <shadow type="math_number">
                        <field name="NUM">1</field>
                    </shadow>
                </value>
                <value name="VALUE">
                    <shadow type="math_number">
                        <field name="NUM">1234567890</field>
                    </shadow>
                </value>
            </block>
            <block type="show_setDisplayFloat">
                <value name="LINE">
                    <shadow type="math_number">
                        <field name="NUM">1</field>
                    </shadow>
                </value>
                <value name="VALUE">
                    <shadow type="math_number">
                        <field name="NUM">1.90</field>
                    </shadow>
                </value>
            </block>
            ${blockSeparator}
            <block type="show_drawPoint">
                <value name="POINTX">
                    <shadow type="math_number">
                        <field name="NUM">10</field>
                    </shadow>
                </value>
                <value name="POINTY">
                    <shadow type="math_number">
                        <field name="NUM">10</field>
                    </shadow>
                </value>
            </block>
            <block type="show_drawLine">
                <value name="LINEX">
                    <shadow type="math_number">
                        <field name="NUM">10</field>
                    </shadow>
                </value>
                <value name="LINEY">
                    <shadow type="math_number">
                        <field name="NUM">10</field>
                    </shadow>
                </value>
                <value name="LINEANGLE">
                    <shadow type="math_number">
                        <field name="NUM">45</field>
                    </shadow>
                </value>
                <value name="LINELENGTH">
                    <shadow type="math_number">
                        <field name="NUM">10</field>
                    </shadow>
                </value>
            </block>
            <block type="show_drawCircle">
                <value name="CIRCLEX">
                    <shadow type="math_number">
                        <field name="NUM">10</field>
                    </shadow>
                </value>
                <value name="CIRCLEY">
                    <shadow type="math_number">
                        <field name="NUM">10</field>
                    </shadow>
                </value>
                <value name="CIRCLERADIUS">
                    <shadow type="math_number">
                        <field name="NUM">5</field>
                    </shadow>
                </value>
            </block>
            <block type="show_drawRectangle">
                <value name="RECTANGLEX">
                    <shadow type="math_number">
                        <field name="NUM">10</field>
                    </shadow>
                </value>
                <value name="RECTANGLEY">
                    <shadow type="math_number">
                        <field name="NUM">10</field>
                    </shadow>
                </value>
                <value name="RECTANGLEWIDTH">
                    <shadow type="math_number">
                        <field name="NUM">50</field>
                    </shadow>
                </value>
                <value name="RECTANGLEHEIGHT">
                    <shadow type="math_number">
                        <field name="NUM">50</field>
                    </shadow>
                </value>
                <value name="RECTANGLELINEWIDTH">
                    <shadow type="math_number">
                        <field name="NUM">2</field>
                    </shadow>
                </value>
            </block>
            <block type="show_drawSolidRectangle">
                <value name="SOLIDRECTANGLEX">
                    <shadow type="math_number">
                        <field name="NUM">10</field>
                    </shadow>
                </value>
                <value name="SOLIDRECTANGLEY">
                    <shadow type="math_number">
                        <field name="NUM">10</field>
                    </shadow>
                </value>
                <value name="SOLIDRECTANGLEWIDTH">
                    <shadow type="math_number">
                        <field name="NUM">50</field>
                    </shadow>
                </value>
                <value name="SOLIDRECTANGLEHEIGHT">
                    <shadow type="math_number">
                        <field name="NUM">50</field>
                    </shadow>
                </value>
            </block>
            ${blockSeparator}
            </category>
            `;
        case 'M6':
            return `
                <category
                    name="%{BKY_CATEGORY_DISPLAY}"
                    id="show"
                    colour="#8dca5d"
                    secondaryColour="#73a749"
                    showLabelButton="true">
                <block type="show_getTouchScreen"/>
                <block type="show_getTouchScreenX"/>
                <block type="show_getTouchScreenY"/>
                ${blockSeparator}
                <block type="show_M6SetLCDBack"/>
                <block type="show_LCDClearScreen"/>
                <block type="show_SetFontSize"/>
                <block type="show_setLineNum">
                    <value name="LINES">
                        <shadow type="math_number">
                            <field name="NUM">1</field>
                        </shadow>
                    </value>
                    <value name="LINENUMBER">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_setColor">
                    <value name="LINES">
                        <shadow type="show_lines_menu">
                        </shadow>
                    </value>
                    <value name="TEXT">
                        <shadow type="text">
                            <field name="TEXT">Hello</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_drawImage">
                    <value name="IMAGEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="IMAGEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="IMAGEFILENAME">
                        <shadow type="text">
                            <field name="TEXT">a.jpg</field>
                        </shadow>
                    </value>
                    <value name="IMAGESCALE">
                        <shadow type="math_number">
                            <field name="NUM">0</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="show_diplayData">
                    <value name="X">
                        <shadow type="show_lines_menu">
                        </shadow>
                    </value>
                    <value name="Y">
                        <shadow type="show_lines_menu">
                        </shadow>
                    </value>
                    <value name="DATA">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_displayCharacter">
                    <value name="X">
                        <shadow type="show_lines_menu">
                        </shadow>
                    </value>
                    <value name="Y">
                        <shadow type="show_lines_menu">
                        </shadow>
                    </value>
                    <value name="CHARACTER">
                        <shadow type="text">
                            <field name="TEXT">Hello</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_setDisplayVarU32">
                    <value name="LINE">
                        <shadow type="math_number">
                            <field name="NUM">1</field>
                        </shadow>
                    </value>
                    <value name="VALUE">
                        <shadow type="math_number">
                            <field name="NUM">1234567890</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_setDisplayFloat">
                    <value name="LINE">
                        <shadow type="math_number">
                            <field name="NUM">1</field>
                        </shadow>
                    </value>
                    <value name="VALUE">
                        <shadow type="math_number">
                            <field name="NUM">1.90</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="show_drawPoint">
                    <value name="POINTX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="POINTY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_drawLine">
                    <value name="LINEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="LINEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="LINEANGLE">
                        <shadow type="math_number">
                            <field name="NUM">45</field>
                        </shadow>
                    </value>
                    <value name="LINELENGTH">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_drawCircle">
                    <value name="CIRCLEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="CIRCLEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="CIRCLERADIUS">
                        <shadow type="math_number">
                            <field name="NUM">5</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_drawRectangle">
                    <value name="RECTANGLEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="RECTANGLEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="RECTANGLEWIDTH">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="RECTANGLEHEIGHT">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="RECTANGLELINEWIDTH">
                        <shadow type="math_number">
                            <field name="NUM">2</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_drawSolidRectangle">
                    <value name="SOLIDRECTANGLEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="SOLIDRECTANGLEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="SOLIDRECTANGLEWIDTH">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="SOLIDRECTANGLEHEIGHT">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                </category>
                `;
        case 'C6':
            return `
                <category
                    name="%{BKY_CATEGORY_DISPLAY}"
                    id="show"
                    colour="#8dca5d"
                    secondaryColour="#73a749"
                    showLabelButton="true">
                <block type="show_getTouchScreen"/>
                <block type="show_getTouchScreenX"/>
                <block type="show_getTouchScreenY"/>
                ${blockSeparator}
                <block type="show_M6SetLCDBack"/>
                <block type="show_LCDClearScreen"/>
                <block type="show_SetFontSize"/>
                <block type="show_setLineNum">
                    <value name="LINES">
                        <shadow type="math_number">
                            <field name="NUM">1</field>
                        </shadow>
                    </value>
                    <value name="LINENUMBER">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_setColor">
                    <value name="LINES">
                        <shadow type="show_lines_menu">
                        </shadow>
                    </value>
                    <value name="TEXT">
                        <shadow type="text">
                            <field name="TEXT">Hello</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_drawImage">
                    <value name="IMAGEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="IMAGEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="IMAGEFILENAME">
                        <shadow type="text">
                            <field name="TEXT">a.jpg</field>
                        </shadow>
                    </value>
                    <value name="IMAGESCALE">
                        <shadow type="math_number">
                            <field name="NUM">0</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="show_diplayData">
                    <value name="X">
                        <shadow type="show_lines_menu">
                        </shadow>
                    </value>
                    <value name="Y">
                        <shadow type="show_lines_menu">
                        </shadow>
                    </value>
                    <value name="DATA">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_displayCharacter">
                    <value name="X">
                        <shadow type="show_lines_menu">
                        </shadow>
                    </value>
                    <value name="Y">
                        <shadow type="show_lines_menu">
                        </shadow>
                    </value>
                    <value name="CHARACTER">
                        <shadow type="text">
                            <field name="TEXT">Hello</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_setDisplayVarU32">
                    <value name="LINE">
                        <shadow type="math_number">
                            <field name="NUM">1</field>
                        </shadow>
                    </value>
                    <value name="VALUE">
                        <shadow type="math_number">
                            <field name="NUM">1234567890</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_setDisplayFloat">
                    <value name="LINE">
                        <shadow type="math_number">
                            <field name="NUM">1</field>
                        </shadow>
                    </value>
                    <value name="VALUE">
                        <shadow type="math_number">
                            <field name="NUM">1.90</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="show_drawPoint">
                    <value name="POINTX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="POINTY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_drawLine">
                    <value name="LINEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="LINEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="LINEANGLE">
                        <shadow type="math_number">
                            <field name="NUM">45</field>
                        </shadow>
                    </value>
                    <value name="LINELENGTH">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_drawCircle">
                    <value name="CIRCLEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="CIRCLEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="CIRCLERADIUS">
                        <shadow type="math_number">
                            <field name="NUM">5</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_drawRectangle">
                    <value name="RECTANGLEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="RECTANGLEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="RECTANGLEWIDTH">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="RECTANGLEHEIGHT">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="RECTANGLELINEWIDTH">
                        <shadow type="math_number">
                            <field name="NUM">2</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_drawSolidRectangle">
                    <value name="SOLIDRECTANGLEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="SOLIDRECTANGLEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="SOLIDRECTANGLEWIDTH">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="SOLIDRECTANGLEHEIGHT">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                </category>
                `;
        case 'E7':
            return `
                <category
                    name="%{BKY_CATEGORY_DISPLAY}"
                    id="show"
                    colour="#8dca5d"
                    secondaryColour="#73a749"
                    showLabelButton="true">
                <block type="E7_getIsTouch"/>
                <block type="E7_GetTouchScreenXY"/>

                <block type="E7_LCDClearScreen"/>
                <block type="E7_setColor">
                    <value name="LINES">
                        <shadow type="show_lines_menu">
                        </shadow>
                    </value>
                    <value name="TEXT">
                        <shadow type="text">
                            <field name="TEXT">Hello</field>
                        </shadow>
                    </value>
                </block>
                <block type="E7_setDisplayStringXYS">
                    <value name="X">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="Y">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="TEXT">
                        <shadow type="text">
                            <field name="TEXT">Hello</field>
                        </shadow>
                    </value>
                </block>
                <block type="E7_SetFontSize"/>
                <block type="E7_drawImage">
                    <value name="IMAGEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="IMAGEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="IMAGEFILENAME">
                        <shadow type="text">
                            <field name="TEXT">a.jpg</field>
                        </shadow>
                    </value>
                    <value name="IMAGESCALE">
                        <shadow type="math_number">
                            <field name="NUM">0</field>
                        </shadow>
                    </value>
                </block>
                <block type="E7_setAlpha">
                    <value name="DATA">
                        <shadow type="math_number">
                            <field name="NUM">1</field>
                        </shadow>
                    </value>
                </block>
                <block type="E7_setZxing">
                    <value name="DATA">
                        <shadow type="text">
                            <field name="TEXT">123</field>
                        </shadow>
                    </value>
                </block>
                <block type="E7_setPaintColor"/>
                
                ${blockSeparator}
                <block type="E7_drawPoint">
                    <value name="POINTX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="POINTY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                </block>
                <block type="E7_drawLine">
                    <value name="LINEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="LINEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="LINEANGLE">
                        <shadow type="math_number">
                            <field name="NUM">45</field>
                        </shadow>
                    </value>
                    <value name="LINELENGTH">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                </block>
                <block type="E7_drawCircle">
                    <value name="CIRCLEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="CIRCLEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="CIRCLERADIUS">
                        <shadow type="math_number">
                            <field name="NUM">5</field>
                        </shadow>
                    </value>
                </block>
                <block type="E7_drawRectangle">
                    <value name="RECTANGLEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="RECTANGLEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="RECTANGLEWIDTH">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="RECTANGLEHEIGHT">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="RECTANGLELINEWIDTH">
                        <shadow type="math_number">
                            <field name="NUM">2</field>
                        </shadow>
                    </value>
                </block>
                <block type="E7_drawSolidRectangle">
                    <value name="SOLIDRECTANGLEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="SOLIDRECTANGLEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="SOLIDRECTANGLEWIDTH">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="SOLIDRECTANGLEHEIGHT">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                </category>
                `;

        case 'STORM_OS':
            return `
                <category
                    name="%{BKY_CATEGORY_DISPLAY}"
                    id="show"
                    colour="#8dca5d"
                    secondaryColour="#73a749"
                    showLabelButton="true">
                <block type="show_getTouchScreen"/>
                <block type="show_getTouchScreenX"/>
                <block type="show_getTouchScreenY"/>
                ${blockSeparator}
                <block type="show_LCDClearScreen"/>
                <block type="show_SetFontSize"/>
                <block type="show_setLineNum">
                    <value name="LINES">
                        <shadow type="math_number">
                            <field name="NUM">1</field>
                        </shadow>
                    </value>
                    <value name="LINENUMBER">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_setColor">
                    <value name="LINES">
                        <shadow type="show_lines_menu">
                        </shadow>
                    </value>
                    <value name="TEXT">
                        <shadow type="text">
                            <field name="TEXT">Hello</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_drawImage">
                    <value name="IMAGEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="IMAGEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="IMAGEFILENAME">
                        <shadow type="text">
                            <field name="TEXT">a.jpg</field>
                        </shadow>
                    </value>
                    <value name="IMAGESCALE">
                        <shadow type="math_number">
                            <field name="NUM">0</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_diplayData">
                    <value name="X">
                        <shadow type="show_lines_menu">
                        </shadow>
                    </value>
                    <value name="Y">
                        <shadow type="show_lines_menu">
                        </shadow>
                    </value>
                    <value name="DATA">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_displayCharacter">
                    <value name="X">
                        <shadow type="show_lines_menu">
                        </shadow>
                    </value>
                    <value name="Y">
                        <shadow type="show_lines_menu">
                        </shadow>
                    </value>
                    <value name="CHARACTER">
                        <shadow type="text">
                            <field name="TEXT">Hello</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="show_drawPoint">
                    <value name="POINTX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="POINTY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_drawLine">
                    <value name="LINEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="LINEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="LINEANGLE">
                        <shadow type="math_number">
                            <field name="NUM">45</field>
                        </shadow>
                    </value>
                    <value name="LINELENGTH">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_drawCircle">
                    <value name="CIRCLEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="CIRCLEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="CIRCLERADIUS">
                        <shadow type="math_number">
                            <field name="NUM">5</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_drawRectangle">
                    <value name="RECTANGLEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="RECTANGLEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="RECTANGLEWIDTH">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="RECTANGLEHEIGHT">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="RECTANGLELINEWIDTH">
                        <shadow type="math_number">
                            <field name="NUM">2</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_drawSolidRectangle">
                    <value name="SOLIDRECTANGLEX">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="SOLIDRECTANGLEY">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                    <value name="SOLIDRECTANGLEWIDTH">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="SOLIDRECTANGLEHEIGHT">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                </category>
                `;
        case 'M5':
            return `
                <category
                    name="%{BKY_CATEGORY_DISPLAY}"
                    id="show"
                    colour="#8dca5d"
                    secondaryColour="#73a749">
                ${blockSeparator}
                <block type="show_M5_SetDisplayVar">
                    <value name="VALUE">
                        <shadow type="math_number">
                            <field name="NUM">0</field>
                        </shadow>
                    </value>
                </block>
                <block type="show_M5_SetDisplayExpression"/>
                ${blockSeparator}
                </category>
                `;
        default:
            return `
                <category
                    name="%{BKY_CATEGORY_DISPLAY}"
                    id="show"
                    colour="#8dca5d"
                    secondaryColour="#73a749">
                </category>
                `;
    }
};

export default showBlock;
